/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { TransitTimeSourceType } from "./TransitTimeSourceType";
import {
  TransitTimeSourceTypeFromJSON,
  TransitTimeSourceTypeFromJSONTyped,
  TransitTimeSourceTypeToJSON,
  TransitTimeSourceTypeToJSONTyped,
} from "./TransitTimeSourceType";
import type { LineItem } from "./LineItem";
import {
  LineItemFromJSON,
  LineItemFromJSONTyped,
  LineItemToJSON,
  LineItemToJSONTyped,
} from "./LineItem";
import type { Location } from "./Location";
import {
  LocationFromJSON,
  LocationFromJSONTyped,
  LocationToJSON,
  LocationToJSONTyped,
} from "./Location";

/**
 *
 * @export
 * @interface AddQuoteBody
 */
export interface AddQuoteBody {
  /**
   *
   * @type {string}
   * @memberof AddQuoteBody
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof AddQuoteBody
   */
  quoteGroupName: string;
  /**
   *
   * @type {Location}
   * @memberof AddQuoteBody
   */
  pickupLocation: Location;
  /**
   *
   * @type {Location}
   * @memberof AddQuoteBody
   */
  deliveryLocation: Location;
  /**
   *
   * @type {Array<LineItem>}
   * @memberof AddQuoteBody
   */
  lineItems: Array<LineItem>;
  /**
   *
   * @type {string}
   * @memberof AddQuoteBody
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof AddQuoteBody
   */
  serviceIdentifier: string;
  /**
   *
   * @type {number}
   * @memberof AddQuoteBody
   */
  carrierPriceOriginalCurrency: number;
  /**
   *
   * @type {CurrencyCode}
   * @memberof AddQuoteBody
   */
  originalCurrency: CurrencyCode;
  /**
   *
   * @type {string}
   * @memberof AddQuoteBody
   */
  carrierQuoteReference: string;
  /**
   *
   * @type {number}
   * @memberof AddQuoteBody
   */
  transitBusinessDays?: number | null;
  /**
   *
   * @type {TransitTimeSourceType}
   * @memberof AddQuoteBody
   */
  transitTimeSource: TransitTimeSourceType;
  /**
   *
   * @type {string}
   * @memberof AddQuoteBody
   */
  transitTimeNotes: string;
  /**
   *
   * @type {boolean}
   * @memberof AddQuoteBody
   */
  customerVisible: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AddQuoteBody
   */
  includesTax: boolean;
  /**
   *
   * @type {string}
   * @memberof AddQuoteBody
   */
  explanation: string;
  /**
   *
   * @type {string}
   * @memberof AddQuoteBody
   */
  emailQuoteRequestId?: string | null;
}

/**
 * Check if a given object implements the AddQuoteBody interface.
 */
export function instanceOfAddQuoteBody(value: object): value is AddQuoteBody {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("quoteGroupName" in value) || value["quoteGroupName"] === undefined)
    return false;
  if (!("pickupLocation" in value) || value["pickupLocation"] === undefined)
    return false;
  if (!("deliveryLocation" in value) || value["deliveryLocation"] === undefined)
    return false;
  if (!("lineItems" in value) || value["lineItems"] === undefined) return false;
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (
    !("serviceIdentifier" in value) ||
    value["serviceIdentifier"] === undefined
  )
    return false;
  if (
    !("carrierPriceOriginalCurrency" in value) ||
    value["carrierPriceOriginalCurrency"] === undefined
  )
    return false;
  if (!("originalCurrency" in value) || value["originalCurrency"] === undefined)
    return false;
  if (
    !("carrierQuoteReference" in value) ||
    value["carrierQuoteReference"] === undefined
  )
    return false;
  if (
    !("transitTimeSource" in value) ||
    value["transitTimeSource"] === undefined
  )
    return false;
  if (!("transitTimeNotes" in value) || value["transitTimeNotes"] === undefined)
    return false;
  if (!("customerVisible" in value) || value["customerVisible"] === undefined)
    return false;
  if (!("includesTax" in value) || value["includesTax"] === undefined)
    return false;
  if (!("explanation" in value) || value["explanation"] === undefined)
    return false;
  return true;
}

export function AddQuoteBodyFromJSON(json: any): AddQuoteBody {
  return AddQuoteBodyFromJSONTyped(json, false);
}

export function AddQuoteBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AddQuoteBody {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    quoteGroupName: json["quoteGroupName"],
    pickupLocation: LocationFromJSON(json["pickupLocation"]),
    deliveryLocation: LocationFromJSON(json["deliveryLocation"]),
    lineItems: (json["lineItems"] as Array<any>).map(LineItemFromJSON),
    carrierIdentifier: json["carrierIdentifier"],
    serviceIdentifier: json["serviceIdentifier"],
    carrierPriceOriginalCurrency: json["carrierPriceOriginalCurrency"],
    originalCurrency: CurrencyCodeFromJSON(json["originalCurrency"]),
    carrierQuoteReference: json["carrierQuoteReference"],
    transitBusinessDays:
      json["transitBusinessDays"] == null
        ? undefined
        : json["transitBusinessDays"],
    transitTimeSource: TransitTimeSourceTypeFromJSON(json["transitTimeSource"]),
    transitTimeNotes: json["transitTimeNotes"],
    customerVisible: json["customerVisible"],
    includesTax: json["includesTax"],
    explanation: json["explanation"],
    emailQuoteRequestId:
      json["emailQuoteRequestId"] == null
        ? undefined
        : json["emailQuoteRequestId"],
  };
}

export function AddQuoteBodyToJSON(json: any): AddQuoteBody {
  return AddQuoteBodyToJSONTyped(json, false);
}

export function AddQuoteBodyToJSONTyped(
  value?: AddQuoteBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    quoteGroupName: value["quoteGroupName"],
    pickupLocation: LocationToJSON(value["pickupLocation"]),
    deliveryLocation: LocationToJSON(value["deliveryLocation"]),
    lineItems: (value["lineItems"] as Array<any>).map(LineItemToJSON),
    carrierIdentifier: value["carrierIdentifier"],
    serviceIdentifier: value["serviceIdentifier"],
    carrierPriceOriginalCurrency: value["carrierPriceOriginalCurrency"],
    originalCurrency: CurrencyCodeToJSON(value["originalCurrency"]),
    carrierQuoteReference: value["carrierQuoteReference"],
    transitBusinessDays: value["transitBusinessDays"],
    transitTimeSource: TransitTimeSourceTypeToJSON(value["transitTimeSource"]),
    transitTimeNotes: value["transitTimeNotes"],
    customerVisible: value["customerVisible"],
    includesTax: value["includesTax"],
    explanation: value["explanation"],
    emailQuoteRequestId: value["emailQuoteRequestId"],
  };
}
